import { Apontamento } from "./Types";
import React from "react";

type Props = {
    apontamentos: Apontamento[];
};

export default function TabelaApontamentosGeral({ apontamentos }: Props) {
    return (
        <div className="table-responsive">
            <table className="table table-striped table-hover align-middle fw-bold" style={{ fontSize: "1.2rem" }}>
                <thead className="table-primary">
                    <tr>
                        <th>Centro</th>
                        <th>Matrícula</th>
                        <th>Ordem</th>
                        <th>Tipo</th>
                        <th>Data</th>
                        <th>Status</th>
                        <th>Resultado</th>
                    </tr>
                </thead>

                <tbody>
                    {apontamentos.length === 0 ? (
                        <tr>
                            <td colSpan={6} className="text-center text-muted">
                                Nenhum apontamento encontrado
                            </td>
                        </tr>
                    ) : (
                        apontamentos.map((item) => (
                            <tr key={item.apont_Key}>
                                <td>{item.centro_Trabalho}</td>
                                <td>{item.nro_Matricula}</td>
                                <td>{item.ordem_Fabricacao}</td>
                                <td>{item.tipo_Apontamento}</td>
                                <td>{new Date(item._ts_Creat    ).toLocaleString()}</td>
                                <td>
                                    <span
                                        className={`badge ${item.integration_Status === "SUCCESS"
                                                ? "bg-success"
                                                : item.integration_Status === "ERROR"
                                                    ? "bg-danger"
                                                    : "bg-secondary"
                                            }`}
                                    >
                                        {item.integration_Status}
                                    </span>
                                </td>
                                <td className="text-balance">
                                    {item.integration_Result || "-"}
                                </td>
                            </tr>
                        ))
                    )}
                </tbody>
            </table>
        </div>
    );
}
